import React, { Fragment, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { getInt } from '../../../../utils/functions';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_CLAUSE_DOCUMENT } from 'constants/rightsCodes';

import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import DocumentClauseContainer from './DocumentClauseContainer';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const Route = props => {
  const historyContext = useHistoryWithContext();
  const [title, setTitle] = useState('');
  const clauseId = props.match.params.clauseId && getInt(props.match.params.clauseId);
  const { getElemByAreaKey } = props;
  const [disabledSave, setDisabledSave] = useState(true);
  const [onSave, setOnSave] = useState({ fn: () => {} });

  const onClickClose = useCallback(() => {
    historyContext.push(`/documentClause`);
  }, [historyContext]);

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setOnSave({ fn });
    setDisabledSave(disabledSave);
  }, []);

  const onChangeDocumentClauseTitle = useCallback(documentClauseTitle => {
    setTitle(documentClauseTitle);
  }, []);

  const onRedirect = useCallback(
    clauseId => {
      historyContext.push(`/documentClause/${clauseId}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} onSave={onSave.fn} disabledSave={disabledSave} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_CLAUSE_DOCUMENT}>
        <DocumentClauseContainer
          clauseId={clauseId}
          onSaveFnChanged={onSaveFnChanged}
          onChangeDocumentClauseTitle={onChangeDocumentClauseTitle}
          onRedirect={onRedirect}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(withRouter(Route));
